<template>
  <div class="paid">
    <img class="paid-img" :src="public_path + '/static/images/success_icon@3x.png'">
    <div class="hint">订单支付成功！</div>
    <div class="hint" style="margin-top: .18rem; color:rgba(51,51,51,0.5);font-size:.28rem;">订单编号：{{order_no}}</div>
  </div>
</template>
<script>
import URL from '../../../static/js/url.js'
export default {
  data () {
    return {
      order_no: URL.getQueryString('order_no'),
      public_path: process.env.PUBLICK_PATH
    }
  },
  mounted () {
  },
  methods: {
    toIndex () {
      let channel_no = localStorage.channel_no
      if (channel_no == 'agent') {
        this.$router.push({
          path: '/'
        })
      } else {
        this.$router.push({
          path: '/ecmall',
          query: {
            channel_no: localStorage.channel_no
          }
        })
      }
      
    },
    toOrder () {
      this.$router.push({
        path: '/ecmall/orders'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.paid {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  .paid-img {
    width: 2.5rem;
    margin: 1rem auto auto;
    display: block;
  }

  .hint {
    font-size: .32rem;
    color: #02B389;
    text-align: center;
    margin-top: 0;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  .hint-2 {
    margin-bottom: .94rem;
    margin-top: .64rem;
  }
}

.button {
  margin-top: .6rem;
  font-size: .30rem;
  display: -webkit-flex;
  padding: .3rem;
  color: #fff;
  .return-btn {
    width: 3.3rem;
    height: .8rem;
    text-align: center;
    background: #02B389;
    border-radius: .4rem;
    line-height: .8rem;
    box-sizing: border-box;
  }
  .order-btn {
    width: 3.3rem;
    height: .8rem;
    text-align: center;
    border-radius: .4rem;
    border: 1px solid #02B389;
    color: #02B389;
    line-height: .8rem;
    margin-left: .3rem;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/buy/buyComPaid.vue